// App.jsx
import React, { useState, useEffect } from "react";
import Login from "./components/Login/Login";
import QRPage from "./components/QRPage/QRPage";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState("user");
  const [scannedData, setScannedData] = useState([]);

  useEffect(() => {
    const loginStatus = localStorage.getItem("isLoggedIn");
    const savedRole = localStorage.getItem("role");
    if (loginStatus === "true") {
      setIsLoggedIn(true);
      setRole(savedRole || "user");
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setRole("user");
    setScannedData([]); // Reset
  };

  return (
    <div>
      {isLoggedIn ? (
        <>
          {(role === "admin" || role === "superadmin") ? (
            <AdminDashboard onLogout={handleLogout} />
          ) : (
            <QRPage
              scannedData={scannedData}
              setScannedData={setScannedData}
              onLogout={handleLogout}
            />
          )}
        </>
      ) : (
        <Login onLogin={() => {
            setIsLoggedIn(true);
            const savedRole = localStorage.getItem("role");
            setRole(savedRole || "user");
          }}
        />
      )}
    </div>
  );
};

export default App;